module.exports = "/_next/static/images/demo-ribbon-pattern-2-c2364909d64179393bed52d910c181df.svg";